module.exports = __webpack_public_path__ + "img/420.af0098da.png";